import React, { memo } from "react";
import { useIntl } from "react-intl";
import { Map, TileLayer, GeoJSON } from "react-leaflet";
import "react-leaflet-fullscreen/dist";
import "react-leaflet-fullscreen/dist/styles.css";
import "./style.scss";

const AreaMap = memo(({ aoiInfo, downloadCar, layers, showLegend = false, ...props }) => {

  const { formatMessage } = useIntl();

  let onlyXY;
  let centroId;
  let dataGeoJSON;

  if (aoiInfo && aoiInfo.B3Area) {
    const aoiInfoOnlyXY = aoiInfo.B3Area.geojson_simplificado.coordinates[0].map(coord => {
      return coord.filter((_, index) => index !== 2);
    })

    onlyXY = aoiInfoOnlyXY;
    centroId = aoiInfo.B3Area.geojson_centroid.coordinates.reverse();
    dataGeoJSON = aoiInfo.B3Area.geojson_simplificado;

  } else if (downloadCar && downloadCar.B3Area) {

    const downloadCarOnlyXY = downloadCar.B3Area.geojson_simplificado.coordinates[0].map(coord => {
      return coord.filter((_, index) => index !== 2);
    })

    onlyXY = downloadCarOnlyXY;
    centroId = downloadCar.B3Area.geojson_centroid.coordinates.reverse();
    dataGeoJSON = downloadCar.B3Area.geojson_simplificado;
  }

  const bounds = onlyXY.map(coord =>
    [...coord].reverse()
  );

  return (
    <>
      <Map
        fullscreenControl
        center={centroId}
        bounds={bounds}
        maxBounds={bounds}
        {...props}
      >

        <TileLayer
          //attribution='&amp;copy <a href="https://www.openstreetmap.org/about">OpenStreetMap</a>'
          // url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          url="http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}"
          minZoom="10"
          subdomains={['mt0', 'mt1', 'mt2', 'mt3']}
        />

        <GeoJSON color="#13FFE8" data={dataGeoJSON} />

        {layers &&
          layers.map(layer =>
            layer.layer.features.map((feature, index) => (
              <GeoJSON
                key={`${layer.slug}-${index}`}
                data={feature.geometry}
                {...layer.style}
              />
            ))
          )}
      </Map>

      {showLegend && (
        <div className="area-map-legend">
          <p className="title">{formatMessage({ id: "legenda" })}</p>
          <p>
            <span
              className="legend-color"
              style={{
                backgroundColor: "#13FFE8"
              }}
            ></span>
            {formatMessage({ id: "area-consultada" })}
          </p>
          {layers &&
            layers.map(layer => (
              <p key={layer.slug}>
                <span
                  className="legend-color"
                  style={{
                    backgroundColor: layer.style && layer.style.color
                  }}
                ></span>
                {layer.name}
              </p>
            ))}
        </div>
      )}
    </>
  );
});

export default AreaMap;
